export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5335.92974e21.jpg";